import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

/**
 * 一份定义，生成两套路由：中文在根（/photoshop），英文在 /en 下（/en/photoshop）。
 *
 * 之前中英文共用同一个 URL、靠 cookie 切换，导致英文内容永远无法被单独收录。
 */
const pageRoutes = [
  { path: '/', name: 'Home', component: () => import('../pages/index') },
  { path: '/v4', name: 'v4', component: () => import('../pages/v4') },
  { path: '/auth-signup', name: 'signup', component: () => import('../pages/auth-signup') },
  { path: '/auth-login', name: 'login', component: () => import('../pages/auth-login') },
  {
    path: '/auth-re-password',
    name: 'reset-password',
    component: () => import('../pages/auth-re-password')
  },
  { path: '/photoshop', name: 'install-photoshop', component: () => import('../pages/photoshop') },
  { path: '/sketch', name: 'install-sketch', component: () => import('../pages/sketch') },
  { path: '/xd', name: 'install-xd', component: () => import('../pages/xd') },
  {
    path: '/illustrator',
    name: 'install-illustrator',
    component: () => import('../pages/illustrator')
  },
  { path: '/figma', name: 'install-figma', component: () => import('../pages/figma') },
  { path: '/jsdesign', name: 'install-jsdesign', component: () => import('../pages/jsdesign') },
  { path: '/mastergo', name: 'install-mastergo', component: () => import('../pages/mastergo') },
  { path: '/mobile', name: 'install-app', component: () => import('../pages/mobile-app') },
  { path: '/blog-list', name: 'blog-list', component: () => import('../pages/page-blog-list') },
  { path: '/help', name: 'help', component: () => import('../pages/page-faqs') },
  { path: '/buy', name: 'buy', component: () => import('../pages/buy') },
  { path: '/team', name: 'team', component: () => import('../pages/buy-team') },
  {
    path: '/member-update',
    name: 'member-update',
    component: () => import('../pages/member-update')
  },
  { path: '/shop-cart', name: 'shop-cart', component: () => import('../pages/shop-cart') },
  { path: '/shop-result', name: 'shop-result', component: () => import('../pages/shop-result') },
  { path: '/profile', name: 'profile', component: () => import('../pages/profile') },
  { path: '/terms', name: 'terms', component: () => import('../pages/terms') },
  { path: '/privacy', name: 'privacy', component: () => import('../pages/page-privacy') }
]

// 英文镜像：/ -> /en，/photoshop -> /en/photoshop
const enRoutes = pageRoutes.map(r => ({
  ...r,
  path: r.path === '/' ? '/en' : `/en${r.path}`,
  name: `en-${r.name}`
}))

const routes = [
  ...pageRoutes,
  ...enRoutes,
  // 由服务端处理，这里只占位以免被 404 兜底吞掉
  { path: '/api/logout', name: 'logout' },
  // 历史遗留的 /zh 前缀，重定向到对应的中文页
  { path: '/zh', redirect: '/' },
  { path: '/zh/*', redirect: to => '/' + to.params.pathMatch },
  { path: '*', component: () => import('../pages/page-error') }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
